const Like = {
    name: 'like',
    globalName: 'Like',
    el: '#like',
    data: function() {
        return {
            debug: true,
        };
    },
    mounted: function() {},
    methods: {
        test: function() {
            console.log('success!');
        },
        add: function (id) {
            if (this.debug) {
                console.log('Добвление товара в избраное ('+id+')');
            }
            $.ajax({
                url: window.SITE_DIR + 'ajax.php',
                data: {
                    'id': id,
                    'action': 'setLike',
                },
                type: 'post',
                dataType: 'json',
                    // $('.mini-wishlist .whish-count').text(response.length);
                    // $('.mini-wishlist .whish-icon').addClass('_active-basket');
                success: this.handlerResponse,
            });
        },
        del: function (id) {
            if (this.debug) {
                console.log('Удаления товара из избраного ('+id+')');
            }
            $.ajax({
                url: window.SITE_DIR + 'ajax.php',
                data: {
                    'id': id,
                    'action': 'removeLike',
                },
                type: 'post',
                dataType: 'json',
                    // $('.mini-wishlist .whish-count').text(response.length);
                    // if (response.length == 0) {
                    //     $('.mini-wishlist .whish-icon').removeClass('_active-basket');
                    // }
                success: this.handlerResponse,
            });
        },
        handlerResponse(response) {
            const favouriteCounterNode = document.querySelector('.whish-count');
            const whishIconNode = document.querySelector('.whish-icon');

            if (whishIconNode) {
                if (response.length) {
                    whishIconNode.classList.add('whish-icon_active');
					favouriteCounterNode.classList.add('count-active');
                } else {
                    whishIconNode.classList.remove('whish-icon_active');
					favouriteCounterNode.classList.remove('count-active');
                }
            }


            if (favouriteCounterNode) {
                favouriteCounterNode.textContent = response.length;
            }
        }
    },
    // components: App.components
};
module.exports = Like;
